import React, { useContext, useEffect, useState } from "react";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import DContext from "../../context/DContext";

import {
  LIGHT_LOGO_URL as logo,
  DARK_LOGO_URL as darkLogo,
} from "../../config/siteConfig";
import toast from "react-hot-toast";
import { COMP_INFO, USER_ROLES } from "../../config/siteConfig";
import { authenticationService } from "../../services/authentication.service";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { Alert } from "react-bootstrap";

import { useLoadingBar } from "react-top-loading-bar";

const Login = () => {
  const { start, complete } = useLoadingBar({ color: "blue", height: 2 });

  const navigate = useNavigate();
  //const {redirecturl} = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const { authState, authDispatch, login, logout } = useContext(DContext);
  const { user } = authState;

  const userRoles = USER_ROLES;

  const [loginInfo, setLoginInfo] = useState({
    // role_code: 1001,
    username: "",
    password: "",
  });

  const [btnDisabled, setBtnDisabled] = useState(false);
  const [btnText, setBtnText] = useState("Login");
  const [loginErr, setLoginErr] = useState({
    message: null,
  });

  const showSwal = (title, text, icon) => {
    withReactContent(Swal).fire({
      title,
      text,
      icon, // 'success' | 'error' | 'warning' | 'info' | 'question'
    });
  };

  const handleChange = (e) => {
    console.log("field changed", e.target.name, e.target.value);
    setLoginInfo({ ...loginInfo, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      if (loginInfo?.username == "" || loginInfo?.password == "") {
        toast.error("Please Enter the Required Fields");
        return;
      }
      start();

      setBtnDisabled(true);
      setBtnText("Please Wait...");
      // const loginRes = await authenticationService.login({
      //     ...loginInfo,
      //     role_code: Number(loginInfo.role_code)
      // });
      //const { role_code, ...loginData } = loginInfo;
      const loginRes = await authenticationService.login(loginInfo);

      console.log("---login res", loginRes);
      if (loginRes.success && loginRes.statusCode == 200) {
        toast.success("Hello " + loginRes?.resData?.user_info?.name);
        localStorage.setItem("token", loginRes.resData.token);
        const menuRes = await authenticationService.getMenuAccess(
          loginRes.resData.user_info.role_code,
        );
        authDispatch({ type: "LOGIN", payload: loginRes.resData.user_info });
        authDispatch({ type: "MENU_LOADED", payload: menuRes.resData });
        authDispatch({
          type: "USER_ROLE_LOADED",
          payload: loginRes.resData.user_info.role,
        });
        authDispatch({
          type: "PROFILE_LOADED",
          payload: loginRes.resData.user_profile_info,
        });

        //redirectRoute();
      } else {
        setLoginErr({
          message: loginRes.response
            ? loginRes.response.data.message
            : loginRes.message,
        });
        //toast.error(loginRes.response ? loginRes.response.data.message : loginRes.message);
        setBtnDisabled(false);
        setBtnText("Login");
      }
    } catch (err) {
      showSwal("Error", "Something went wrong...", "error");
    } finally {
      complete();
    }
  };

  const redirectRoute = () => {
    let redirectUrl = searchParams.get("redirecturl");
    if (redirectUrl !== null) {
      console.log("redirect url found", redirectUrl);
      navigate(`/${redirectUrl}`);
    } else {
      navigate("/");
    }
  };

  useEffect(() => {}, []);

  return (
    <>
      <style>{`
        .login_mobile_brand { display: none; }
        @media (max-width: 767.98px) {
          .auth_login .auth_bg { height: 100dvh; }
          .auth_login .auth_bg .auth_content {
            width: 100%; height: 100%; border-radius: 0; box-shadow: none; background: transparent;
            flex-direction: column; overflow-y: auto; padding: 32px 16px;
          }
          .auth_login .auth_bg .auth_content .flex50 { max-width: 100%; flex: 0 0 auto; }
          .auth_login .auth_right {
            height: auto !important; overflow: visible !important; padding: 28px 22px !important;
            border-radius: 20px; box-shadow: 0 20px 60px rgba(15,37,87,0.15);
            max-width: 440px; margin: 0 auto;
          }
          .auth_login .login_mobile_brand {
            display: flex; flex-direction: column; align-items: center; text-align: center;
            width: 100%; margin-bottom: 20px; padding-bottom: 16px; border-bottom: 1px solid #eef0f8;
          }
          .auth_login .login_mobile_brand img { height: 48px; max-width: 70vw; object-fit: contain; margin-bottom: 8px; }
          .auth_login .login_mobile_name { font-size: 14px; font-weight: 800; color: #1e3a6e; text-transform: uppercase; letter-spacing: 0.6px; }
          .auth_login .login_mobile_sub { font-size: 11px; color: #a0aec0; margin-top: 2px; }
          .auth_login .auth_right form input { font-size: 16px !important; }
        }
      `}</style>
      <div className="auth_login">
        <div className="auth_bg">
          <div className="auth_content">
            {/* Left panel — hidden on mobile */}
            <div className="flex50 d-none d-md-flex">
              <div className="auth_left">
                <div className="bg_caption">
                  <div className="bg_caption_welcome">
                    <Link to="/">
                      <img src={logo} className="mb-3" alt="" />
                    </Link>
                    <h4 className="fw-bold">{COMP_INFO.NAME}</h4>
                    <div className="bg_caption_signup">
                      <p>Become a Supplier</p>
                      <Link to="/signup">Register Now</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right panel — full width on mobile */}
            <div className="flex50" style={{ flex: "1 1 auto", minWidth: 0 }}>
              <div
                className="auth_right"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  overflowY: "auto",
                  padding: "32px 20px",
                  background: "rgba(255,255,255,0.95)",
                  backdropFilter: "blur(24px)",
                }}
              >
                <div style={{ width: "100%", maxWidth: "400px" }}>
                  {/* Mobile-only: brand header (dark logo on white card) */}
                  <div className="login_mobile_brand d-md-none">
                    <Link to="/">
                      <img src={darkLogo} alt={COMP_INFO.NAME} />
                    </Link>
                    <div className="login_mobile_name">{COMP_INFO.NAME}</div>
                    {/* <div className="login_mobile_sub">Supplier Dashboard</div> */}
                  </div>

                  {/* Page header */}
                  <div style={{ marginBottom: "24px" }} className="text-center">
                    <h4
                      style={{
                        fontWeight: "800",
                        color: "#1e3a6e",
                        fontSize: "19px",
                        marginBottom: "3px",
                      }}
                    >
                      Welcome back
                    </h4>
                    <p
                      style={{ color: "#a0aec0", fontSize: "13px", margin: 0 }}
                    >
                      Sign in to your supplier dashboard
                    </p>
                  </div>

                  <form onSubmit={handleSubmit}>
                    {/* Error */}
                    {loginErr?.message && (
                      <div
                        style={{
                          background: "#fff4f4",
                          border: "1.5px solid #fecaca",
                          borderRadius: "10px",
                          padding: "10px 14px",
                          color: "#c45252",
                          fontSize: "13px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          marginBottom: "20px",
                        }}
                      >
                        <i
                          className="bi bi-exclamation-circle-fill"
                          style={{ flexShrink: 0 }}
                        ></i>
                        {loginErr.message}
                      </div>
                    )}

                    {/* Role Selector */}
                    <div style={{ marginBottom: "20px" }}>
                      {/* <span
                        style={{
                          fontSize: "11px",
                          fontWeight: "700",
                          color: "#a0aec0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                          display: "block",
                          marginBottom: "10px",
                        }}
                      >
                        Select Role
                      </span> */}

                      {/* <div
                        className="d-none d-md-flex"
                        style={{ gap: "8px", flexWrap: "wrap" }}
                      >
                        {userRoles.map((roleType) => {
                          const isSelected =
                            loginInfo.role_code == roleType.role_code;
                          console.log(
                            "rendering role",
                            roleType.role,
                            "selected:",
                            isSelected,
                          );
                          return (
                            <React.Fragment key={roleType.role_code}>
                              <input
                                type="radio"
                                className="btn-check"
                                name="role_code"
                                id={`role-${roleType.role_code}`}
                                autoComplete="off"
                                value={roleType.role_code}
                                onChange={handleChange}
                              />
                              <label
                                htmlFor={`role-${roleType.role_code}`}
                                style={{
                                  flex: "1 1 60px",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: "5px",
                                  padding: "10px 8px",
                                  borderRadius: "12px",
                                  cursor: "pointer",
                                  transition: "all 0.15s",
                                  border: `1.5px solid ${isSelected ? "#5b84c4" : "#e8ecf4"}`,
                                  background: isSelected
                                    ? "#eef2fb"
                                    : "#fafbfd",
                                  fontSize: "10px",
                                  fontWeight: "700",
                                  color: isSelected ? "#1e3a6e" : "#9ca3af",
                                  boxShadow: isSelected
                                    ? "0 2px 8px rgba(91,132,196,0.18)"
                                    : "none",
                                }}
                              >
                                <i
                                  className={roleType.icon}
                                  style={{
                                    fontSize: "15px",
                                    color: isSelected ? "#2d4f8e" : "#c0cad8",
                                  }}
                                ></i>
                                {roleType.role}
                              </label>
                            </React.Fragment>
                          );
                        })}
                      </div> */}

                      {/* Mobile: styled select */}
                      {/* <select
                        className="d-block d-md-none"
                        name="role_code"
                        onChange={handleChange}
                        style={{
                          width: "100%",
                          padding: "11px 14px",
                          border: "1.5px solid #e8ecf4",
                          borderRadius: "10px",
                          fontSize: "13px",
                          color: "#4b5563",
                          background: "#fafbfd",
                          outline: "none",
                        }}
                      >
                        <option value="">Select Role</option>
                        {userRoles.map((roleType) => (
                          <option
                            value={roleType.role_code}
                            key={roleType.role_code}
                          >
                            {roleType.role}
                          </option>
                        ))}
                      </select> */}
                    </div>

                    {/* Username */}
                    <div style={{ marginBottom: "14px" }}>
                      <label
                        style={{
                          fontSize: "11px",
                          fontWeight: "700",
                          color: "#a0aec0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                          display: "block",
                          marginBottom: "8px",
                        }}
                      >
                        Username
                      </label>
                      <div style={{ position: "relative" }}>
                        <i
                          className="bi bi-person"
                          style={{
                            position: "absolute",
                            left: "14px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#c0cad8",
                            fontSize: "14px",
                          }}
                        ></i>
                        <input
                          type="text"
                          name="username"
                          id="username"
                          placeholder="Enter your username"
                          onChange={handleChange}
                          style={{
                            width: "100%",
                            padding: "12px 14px 12px 40px",
                            border: "1.5px solid #e8ecf4",
                            borderRadius: "10px",
                            fontSize: "13px",
                            color: "#1e3a6e",
                            background: "#fafbfd",
                            outline: "none",
                            transition: "border-color 0.15s, box-shadow 0.15s",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#5b84c4";
                            e.target.style.boxShadow =
                              "0 0 0 3px rgba(91,132,196,0.12)";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#e8ecf4";
                            e.target.style.boxShadow = "none";
                          }}
                        />
                      </div>
                    </div>

                    {/* Password */}
                    <div style={{ marginBottom: "10px" }}>
                      <label
                        style={{
                          fontSize: "11px",
                          fontWeight: "700",
                          color: "#a0aec0",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                          display: "block",
                          marginBottom: "8px",
                        }}
                      >
                        Password
                      </label>
                      <div style={{ position: "relative" }}>
                        <i
                          className="bi bi-lock"
                          style={{
                            position: "absolute",
                            left: "14px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#c0cad8",
                            fontSize: "14px",
                          }}
                        ></i>
                        <input
                          type="password"
                          name="password"
                          id="password"
                          placeholder="Enter your password"
                          onChange={handleChange}
                          style={{
                            width: "100%",
                            padding: "12px 14px 12px 40px",
                            border: "1.5px solid #e8ecf4",
                            borderRadius: "10px",
                            fontSize: "13px",
                            color: "#1e3a6e",
                            background: "#fafbfd",
                            outline: "none",
                            transition: "border-color 0.15s, box-shadow 0.15s",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#5b84c4";
                            e.target.style.boxShadow =
                              "0 0 0 3px rgba(91,132,196,0.12)";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#e8ecf4";
                            e.target.style.boxShadow = "none";
                          }}
                        />
                      </div>
                    </div>

                    {/* Forgot password */}
                    <div style={{ textAlign: "right", marginBottom: "24px" }}>
                      <Link
                        to="/forgot-password"
                        style={{ textDecoration: "none" }}
                      >
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#5b84c4",
                            fontWeight: "600",
                          }}
                        >
                          Forgot Password?
                        </span>
                      </Link>
                    </div>

                    {/* Submit */}
                    <button
                      type="submit"
                      disabled={btnDisabled}
                      style={{
                        width: "100%",
                        padding: "13px",
                        background: btnDisabled
                          ? "#c9d6ee"
                          : "linear-gradient(135deg, #2d4f8e 0%, #5b84c4 100%)",
                        color: "white",
                        border: "none",
                        borderRadius: "12px",
                        fontSize: "14px",
                        fontWeight: "700",
                        letterSpacing: "0.3px",
                        cursor: btnDisabled ? "not-allowed" : "pointer",
                        transition: "all 0.2s",
                        boxShadow: btnDisabled
                          ? "none"
                          : "0 4px 14px rgba(45,79,142,0.28)",
                      }}
                      onMouseEnter={(e) => {
                        if (!btnDisabled) {
                          e.currentTarget.style.transform = "translateY(-1px)";
                          e.currentTarget.style.boxShadow =
                            "0 6px 20px rgba(45,79,142,0.38)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "";
                        e.currentTarget.style.boxShadow = btnDisabled
                          ? "none"
                          : "0 4px 14px rgba(45,79,142,0.28)";
                      }}
                    >
                      <i
                        className={`bi ${btnDisabled ? "bi-hourglass-split" : "bi-box-arrow-in-right"} me-2`}
                      ></i>
                      {btnText}
                    </button>

                    {/* API documentation link */}
                    <div className="text-center mt-3">
                      <a
                        href="https://api-supplier.virtualtoactual.cloud/service-api-documentation"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          textDecoration: "none",
                          fontSize: "12px",
                          color: "#5b84c4",
                          fontWeight: "600",
                        }}
                      >
                        <i className="bi bi-code-slash me-1"></i>
                        We are offering API — View API Documentation
                      </a>
                    </div>

                    {/* Mobile: register link */}
                    <div className="d-flex d-md-none justify-content-center mt-4">
                      <span style={{ fontSize: "12px", color: "#a0aec0" }}>
                        New supplier?&nbsp;
                      </span>
                      <Link to="/signup" style={{ textDecoration: "none" }}>
                        <span
                          style={{
                            fontSize: "12px",
                            color: "#2d4f8e",
                            fontWeight: "700",
                          }}
                        >
                          Register Now
                        </span>
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
